import { geojsonToBinary } from '@loaders.gl/gis';
import { parseJSONInBatches } from "./lib/parsers/parse-json-in-batches.js";
const VERSION = typeof "4.1.0-alpha.9" !== 'undefined' ? "4.1.0-alpha.9" : 'latest';
export const GeoJSONWorkerLoader = {
  name: 'GeoJSON',
  id: 'geojson',
  module: 'geojson',
  version: VERSION,
  worker: true,
  extensions: ['geojson'],
  mimeTypes: ['application/geo+json'],
  category: 'geometry',
  text: true,
  options: {
    geojson: {
      shape: 'object-row-table'
    },
    json: {
      shape: 'object-row-table',
      jsonpaths: ['$', '$.features']
    },
    gis: {
      format: 'geojson'
    }
  }
};
export const GeoJSONLoader = {
  ...GeoJSONWorkerLoader,
  parse,
  parseTextSync,
  parseInBatches
};
async function parse(arrayBuffer, options) {
  return parseTextSync(new TextDecoder().decode(arrayBuffer), options);
}
function parseTextSync(text, options) {
  var _geojson;
  options = {
    ...GeoJSONLoader.options,
    ...options
  };
  options.geojson = {
    ...GeoJSONLoader.options.geojson,
    ...options.geojson
  };
  options.gis = options.gis || {};
  let geojson;
  try {
    geojson = JSON.parse(text);
  } catch {
    geojson = {};
  }
  const table = {
    shape: 'geojson-table',
    type: 'FeatureCollection',
    features: ((_geojson = geojson) === null || _geojson === void 0 ? void 0 : _geojson.features) || []
  };
  switch (options.gis.format) {
    case 'binary':
      return geojsonToBinary(table.features);
    default:
      return table;
  }
}
function parseInBatches(asyncIterator, options) {
  options = {
    ...GeoJSONLoader.options,
    ...options
  };
  options.json = {
    ...GeoJSONLoader.options.geojson,
    ...options.geojson
  };
  const geojsonIterator = parseJSONInBatches(asyncIterator, options);
  switch (options.gis.format) {
    case 'binary':
      return makeBinaryGeometryIterator(geojsonIterator);
    default:
      return geojsonIterator;
  }
}
async function* makeBinaryGeometryIterator(geojsonIterator) {
  for await (const batch of geojsonIterator) {
    batch.data = geojsonToBinary(batch.data);
    yield batch;
  }
}
//# sourceMappingURL=geojson-loader.js.map